<!-- Do not change this file. -->
<template>
  <div
    class="
      container-fluid
      bg-secondary-subtle
      border-bottom border-secondary-subtle
    "
    style="margin-top: -15px"
  >
    <div class="container text-start d-flex p-3">
      <div class="fw-bold text-danger border-end border-secondary pe-3 me-3">
        Administrator
      </div>
      <RouterLink
        v-for="route in mappedRoutes"
        :key="route.name"
        :to="{ name: route.name }"
        class="nav-link me-3"
        >{{ route.label }}</RouterLink
      >
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import { routes } from "@/router";
export default {
  name: "AdminNavbar",
  computed: {
    mappedRoutes() {
      return routes
        .filter((route) => route.path.includes("/admin"))
        .map((route) => {
          route.label = route.meta?.label ?? route.name;
          return route;
        });
    }
  }
};
</script>
